
import React, { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-slate-200 py-4">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center w-full text-left font-semibold text-slate-900 hover:text-slate-700 transition-colors py-2"
      >
        <span>{question}</span>
        <i className={`fa-solid fa-chevron-down text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      <div className={`mt-2 text-slate-600 text-sm overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
        <p className="pb-4 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
};

const FAQ: React.FC = () => {
  const faqs = [
    {
      question: "¿Hacen envíos a todo Perú?",
      answer: "Sí, realizamos envíos seguros y embalados con máxima protección a todas las provincias del Perú vía Olva Courier o la agencia de su preferencia."
    },
    {
      question: "¿Qué garantía tiene el acero?",
      answer: "Nuestros productos cuentan con garantía de por vida contra la oxidación, gracias al uso exclusivo de acero inoxidable quirúrgico calidad 304."
    },
    {
      question: "¿Cuáles son los métodos de pago?",
      answer: "Aceptamos transferencias bancarias (BCP, Interbank, BBVA), pagos vía Yape o Plin, y tarjetas de crédito a través de links de pago seguros."
    },
    {
      question: "¿Viene armada o desarmada?",
      answer: "La mesa se entrega completamente armada y lista para usar, asegurando la rigidez y el acabado perfecto de fábrica."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900">Preguntas Frecuentes</h2>
        </div>
        <div className="bg-white rounded-2xl p-6 sm:p-10 shadow-sm border border-slate-100">
          {faqs.map((f, idx) => (
            <FAQItem key={idx} question={f.question} answer={f.answer} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
